import { createStore } from 'satcheljs';

export default createStore('timeStreamToolboxCommonViewState', {
    showExpandedToolbox: false,
    defaultToolboxHeight: 0,
    toolboxHeight: 0,
});
